module.exports = __webpack_public_path__ + "img/INF-A-1-III.634d132f.png";